const BASE_URL = process.env.REACT_APP_ZVB_URL || "http://localhost:8000/api";

export const storeQuoteRequest = async (payload) => {
  try {
    const response = await fetch(`${BASE_URL}/quoterequests`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || `HTTP ${response.status}`);
    }

    return data;
  } catch (error) {
    console.error("Error while trying to create a quote request", error);
    throw error;
  }
};
